import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../configuration/setup/store';

export const selectSideMenu = (state: RootState) => state.sideMenu;
export const selectCurrentCategory = createSelector(selectSideMenu, (state) => state.currentCategory);
export const selectIsSideMenuOpen = createSelector(selectSideMenu, (state) => state.isSideMenuOpen);
